module.exports = {
      id: "culture-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#culture-usage",
      toString: function () {
        return this.url;
      }
    }